const modelTypes = Object.freeze({
	initialState: 'INITIAL_STATE',
	criticalState: 'CRITICAL_STATE',
    storeId: 'STORE_ID',
    resources: 'RESOURCES',

    catalogSettings: 'CATALOG_SETTINGS',
    catalogProductsModel: 'CATALOG_PRODUCTS_MODEL',

    homepageProducts: 'HOMEPAGE_PRODUCTS',
    newProducts: 'NEW_PRODUCTS',
    bestSellingProducts: 'BEST_SELLING_PRODUCTS',

	homepageCategories: 'HOMEPAGE_CATEGORIES',
	homepageNews: 'HOMEPAGE_NEWS',
	homepageSlider: 'HOMEPAGE_SLIDER',
	homepageTopic: 'HOMEPAGE_TOPIC',
	homepagePolls: 'HOMEPAGE_POLLS',

	navbarLanguages: 'NAVBAR_LANGUAGES',
	navbarHeaderLinks: 'NAVBAR_HEADER_LINKS',
	navbarMenu: 'NAVBAR_MENU',
	navbarSearchBox: 'NAVBAR_SEARCH_BOX',
	navbarVat: 'NAVBAR_VAT',
	navbarLogo: 'NAVBAR_LOGO',
	navbarMotivators: 'NAVBAR_MOTIVATORS',

	categoryCurrentPage: 'CATEGORY_CURRENT_PAGE',
	searchPage: 'SEARCH_PAGE',
	accountPage: 'ACCOUNT_PAGE',
	topicPage: 'TOPIC_PAGE',
	cartPage: 'CART_PAGE',
	checkoutPage: 'CHECKOUT_PAGE',
    vendorPage: 'VENDOR_PAGE',

	// misc catalog pages
	recentlyViewedProducts: 'RECENTLY_VIEWED_PRODUCTS',

	productDetails: 'PRODUCT_DETAILS',
	extendedDescription: 'PRODUCT_EXTENDED_DESCRIPTION',
	productDocuments: 'PRODUCT_DOCUMENTS',
    productSpecifications: 'PRODUCT_SPECIFICATIONS',
    productSpecificationOptions: 'PRODUCT_SPECIFICATION_OPTIONS',
    productVideo: 'PRODUCT_VIDEO',
	productsToCompare: 'PRODUCTS_TO_COMPARE',
    productsByTag: 'PRODUCTS_BY_TAG',

    footer: 'SITE_FOOTER',
    footerCopyright: 'SITE_FOOTER_COPYRIGHT',
    footerLinks: 'SITE_FOOTER_LINKS',
    footerTopics: 'SITE_FOOTER_TOPICS',
    newsletterSettings: 'NEWSLETTER_SETTINGS',
    socialSettings: 'SOCIAL_SETTINGS',


    manufacturers: 'MANUFACTURER_LIST',

	addToCart: 'ADD_TO_CART',
    breadcrumbs: 'BREADCRUMBS',

    cartSettings: 'CART_SETTINGS',
    orderSettings: 'ORDER_SETTINGS',
    currentCustomer: 'CURRENT_CUSTOMER',

	mainStoreUrl: 'MAIN_STORE_URL',

    // No redux!
    routes: '__ROUTES',
})

export { modelTypes }

export default modelTypes
